@if (control?.touched && control?.errors) {
  @if (customErrorMessage) {
    <p class="text-danger">
      {{ customErrorMessage }}
    </p>
  }
  @if (!customErrorMessage) {
    @for (error of (control?.errors ?? {}) | keyvalue; track error) {
      @if (error.key !== 'required') {
        <p class="text-danger mb-0">
          {{ error.value ?? '!!!missing-error-text!!!' }}
        </p>
      }
    }
  }
}
